import { formatRequestDuration } from './chatCopyFormat';

function formatResearchDebugHeader(job) {
  if (!job || typeof job !== 'object') return '';
  const status = String(job.status || 'unknown').toLowerCase();
  const time = formatRequestDuration(job.startedAt || job.createdAt, job.completedAt || job.updatedAt);
  return `Status: ${status} • Time: ${time}`;
}

function formatStepBody(step, index) {
  const action = String(step.actionType || 'step');
  const summary = String(step.summary || '').trim();
  const lines = [`[${index + 1}] ${action}: ${summary}`];
  if (step.rawPayload != null) {
    try {
      const payload =
        typeof step.rawPayload === 'string'
          ? step.rawPayload
          : JSON.stringify(step.rawPayload, null, 2);
      if (payload && payload !== '{}' && payload !== 'null') {
        lines.push(payload);
      }
    } catch (_) {
      lines.push(String(step.rawPayload));
    }
  }
  return lines.join('\n');
}

/**
 * Copy/paste audit text for Deep Research tool-output debug (mirrors Thinking History).
 */
export function formatResearchToolOutputAudit(steps, { job } = {}) {
  const list = Array.isArray(steps) ? steps : [];
  const parts = [];

  const header = formatResearchDebugHeader(job);
  if (header) parts.push(header);

  if (job?.error) {
    parts.push(`Error: ${job.error}`);
  }

  if (list.length === 0) {
    return parts.join('\n\n');
  }

  const sorted = [...list].sort((a, b) => {
    const an = Number(a.stepNumber);
    const bn = Number(b.stepNumber);
    if (Number.isFinite(an) && Number.isFinite(bn) && an !== bn) return an - bn;
    return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
  });

  parts.push(sorted.map((step, index) => formatStepBody(step, index)).join('\n\n'));
  return parts.join('\n\n');
}

export { formatRequestDuration as formatResearchDuration };
